module.exports = __webpack_public_path__ + "img/fondo.11c32e26.jpg";